import { Injectable, Input } from "@angular/core";
import { API_METHODS, API_URL, OperationType } from "common/constants/sm-constants";
import { environment } from 'src/environments/environment';
import { FormDataService } from "../base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { TrainersStudentModel } from "common/models/page-models/Trainer Student/trainers-student-data.model";
import { TrainersModel } from "common/models/page-models/Trainers Model/trainers-data.model";



@Injectable({
    providedIn: 'root'
})
export class TrainersStudentFormDataService extends FormDataService<TrainersStudentModel> {
    // @Input() override pageData: any = {};

    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.trainerStudentFormDetails, http, ss);
        
    }

    override getEditUrlAndMethod() {
       
        const edit = {
            url: environment.apiUrl + API_URL.trainerStudentFormDetails,
            method: API_METHODS.post, 

        }
        return edit;
    }

    // override getUpdatePayload(data) {
    //     console.log(data,'data')
    //     let payload;
    //     payload = {
            
    //         trainer_id: data.trainer_id,
           
    //     }
    //     return payload;
    // }

    override getDetailCustomUrl() {
        const edit = {
            url: API_URL.trainerStudentFormDetails,
            method: API_METHODS.get
        }
        return edit;
    }


    override modifyAPIResponse(response: any) {
        const dataModel = this.createInstance();   
        dataModel.trainer_id = response?.details?.trainer_id;
        dataModel.first_name = response?.details?.first_name;
        dataModel.last_name = response?.details?.last_name;
        dataModel.email = response?.details?.email;
        dataModel.mobile_number = response?.details?.mobile_number;
        // console.log(response);
        dataModel.category_id = response?.details?.category.map((a) => a.id);

        return dataModel;
    }
    
    override afterGetData(model: TrainersStudentModel): Promise<TrainersStudentModel> {
        return new Promise<any>((resolve, reject) => {
          model.id=model.trainer_id;
          resolve(model)
        });
      }

    override getUpdateUrl() {
        return API_URL.trainersUpdates;
    }

    createInstance(): TrainersStudentModel {
        return new TrainersStudentModel();
    }

}

export { FormDataService };
